export const VisitSource = {
  SWIPE: 'swipe',
  SEARCH: 'search',
  MATCH: 'match',
  DIRECT: 'direct',
  SUGGESTION: 'suggestion',
  NOTIFICATION: 'notification',
} as const;

export type VisitSourceValue = (typeof VisitSource)[keyof typeof VisitSource];

export interface ProfileVisitActor {
  kind: 'character' | 'user';
  display_name: string;
  avatar_url?: string;
  target_path?: `/characters/${number}`;
}

export interface ProfileVisit {
  id: number;
  character_id?: number;
  visit_duration?: number;
  visit_source?: VisitSourceValue;
  triggered_message: boolean;
  visit_score: number;
  created_at: string;
  actor: ProfileVisitActor;
}

export interface ProfileVisitStats {
  total_visits: number;
  unique_visitors: number;
  character_visits: number;
  user_visits: number;
}
